import React from 'react';
import { IIcon } from '../../@types/icons';

export function CloseCircleRed ({ onClick }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      onClick={onClick}
    >
      <path
        stroke="#EF374E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 19.286A9.286 9.286 0 1110 .714a9.286 9.286 0 010 18.572z"
      />
      <path
        stroke="#EF374E"
        strokeLinecap="round"
        d="M8 8l4 4M12 8l-4 4"
      />
    </svg>
  );
}
